<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewPackageSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('clicked',false);$refs.simpleRules.reset();userData=blankUserData"
    @change="(val) => $emit('one')"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add Plan
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        ref="simpleRules"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
          v-if="userData"
        >

          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="Display Name"
            rules="required"
          >
            <b-form-group
              label="Plan Code"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="userData.label"
                autofocus

                trim
                placeholder="Plan Code"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="type"
            rules="required"
          >
            <b-form-group
              label="Type"
              label-for="Type"

            >
              <v-select
                v-model="userData.type"
                :options="typeOptions"
                :clearable="false"
                input-id="type"
                :reduce="val => val.value"
              />
              <b-form-invalid-feedback >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="amount"
            rules="required|between:0,1000000"
          >
            <b-form-group
              label="Amount"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="userData.amount"

                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="period"
            rules="required|between:0,1000"
          >
            <b-form-group
              label="Period Quantity"
              label-for="quantity Quantity"
            >
              <b-form-input
                id="period quantity"
                v-model="userData.period_quantity"
                class="text-uppercase"

                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <validation-provider
            #default="validationContext"
            name="unit"
            rules="required"
          >
            <b-form-group
              label="Unit"
              label-for="unit"

            >
              <v-select
                v-model="userData.period_unit"
                :options="unitOptions"
                :clearable="false"
                input-id="type"
                :reduce="val => val.value"
              />
              <b-form-invalid-feedback >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <validation-provider
            #default="validationContext"
            name="has_commission"
            rules="required"
          >
            <b-form-group
              label="Commission"
              label-for="Commission"

            >
              <v-select
                v-model="userData.has_commission"
                :options="YNOptions"
                :clearable="false"
                input-id="type"
                :reduce="val => val.value"
              />
              <b-form-invalid-feedback >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="duration"
            rules="required|between:0,180"
          >
            <b-form-group
              label="Class Credit"
              label-for="Class Credit"
            >
              <b-form-input
                id="Class Credit"
                v-model="userData.class_credit"

                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!--<validation-provider
            #default="validationContext"
            name="class_credit_unit"
            rules="required"
          >
            <b-form-group
              label="Class Credit Unit"
              label-for="Class Credit Unit"

            >
              <v-select
                v-model="userData.class_credit_unit"
                :options="class_credit_options"
                :clearable="false"
                input-id="type"
                :reduce="val => val.value"
              />
              <b-form-invalid-feedback >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
-->


          <validation-provider
            #default="validationContext"
            name="status"
            rules="required"
          >
            <b-form-group
              label="Status"
              label-for="Status"

            >
              <v-select
                v-model="userData.status"
                :options="statusOptions"
                :clearable="false"
                input-id="type"
                :reduce="val => val.value"
              />
              <b-form-invalid-feedback >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2 mb-5">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="button"
              :disabled="processing"
              @click="submit_now()"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>

          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import countries from '@/@fake-db/data/other/countries'

export default {
  components: {
    ToastificationContent,
    flatPickr,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewPackageSidebarActive',
    event: 'update:is-add-new-Package-sidebar-active',
  },
  props: {
    isAddNewPackageSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      processing:false,
      typeOptions: [
        { label: 'TERMS', value: 'TERMS' },
        { label: 'DUES', value: 'DUES' },
      ],
      class_credit_options: [
        { label: 'TOTAL', value: 'TOTAL' },
        { label: 'AVERAGE', value: 'AVERAGE' },
      ],
      statusOptions: [
        { label: 'ACTIVE', value: "ACTIVE" },
        { label: 'DISABLED', value: "DISABLED" },
      ],
      unitOptions: [
        { label: 'DAYS', value: 'DAYS' },
        { label: 'MONTHS', value: 'MONTHS' },
      ],
      YNOptions: [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' },
      ],
      userData: {
        has_commission: "N",
        status: "ACTIVE",
      },
      required,
      alphaNum,
      email,
      countries,
      blankUserData: {
        display_name: '',
        username: '',
        password: '',
        role: 'admin',
        status: '',
        has_commission: 'N',

      },
    }
  },
  methods: {

    resetForm() {

    },
    submit_now() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
        //  this.processing = true
          this.$http.post(process.env.VUE_APP_API_BASE+'/plan/add/', this.userData)
            .then(res => {
              if (res.data.result === true) {
                this.processing = false
                this.$emit('clicked', false)
                this.userData = this.blankUserData
                this.$refs.simpleRules.reset()
              } else {
                this.processing = false
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-center',
                  props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: res.data.message,
                  },
                })
              }
            })
        }
      })
    },
  },
  setup(props, { emit }) {
    const blankUserData = {
      display_name: '',
      username: '',
      password: '',
      role: 'admin',
      status: 'active',
    }

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }

    const onSubmit = () => {

    }

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
